import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, EventEmitter, ViewContainerRef } from '@angular/core';
import { util } from '../../../classes/util';
import { environment } from '../../../environment';
import { InputConverter } from '../../../inputConverter';
import { ExportService } from '../../../services/export.service';
import { FilterService } from '../../../services/filter.service';
import { LayerService } from '../../../services/layer.service';
import { BaseComponent } from '../../base.component';
/** Basic Filter Component - Allows editing of a layer filter */
var LayerFilterContainerComponent = /** @class */ (function (_super) {
    tslib_1.__extends(LayerFilterContainerComponent, _super);
    function LayerFilterContainerComponent(_vcr, layerService, filterService, exportService, cdr) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.layerService = layerService;
        _this.filterService = filterService;
        _this.exportService = exportService;
        _this.cdr = cdr;
        _this.enableGeographicFilter = true;
        _this.enableJoinFilter = true;
        _this.enableChildRecordFilter = true;
        _this.loading = false;
        _this.onapply = new EventEmitter();
        _this.ondone = new EventEmitter();
        _this.onlayerdata = new EventEmitter();
        _this.onboundarysourcechanged = new EventEmitter();
        _this.currentTabIndex = 0;
        _this.showJoinFilter = true;
        _this.showChildRecordFilter = true;
        _this.showGeographicFilter = true;
        _this.exportEnabled = false;
        _this.joinFilterList = [];
        _this.childFilterList = [];
        _this.geographicFilterList = [];
        _this.registerEvent('onapply', _this.onapply);
        _this.registerEvent('ondone', _this.ondone);
        _this.registerEvent('onboundarysourcechanged', _this.onboundarysourcechanged);
        return _this;
    }
    Object.defineProperty(LayerFilterContainerComponent.prototype, "layerId", {
        get: function () {
            return this._esriLayerId;
        },
        set: function (value) {
            if (this._esriLayerId !== value) {
                this.activateTab(0);
            }
            this._esriLayerId = value;
            if (this._esriLayerId) {
                this.setupFilter(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayerFilterContainerComponent.prototype, "extraQuery", {
        get: function () {
            return this._extraQuery;
        },
        set: function (value) {
            this._extraQuery = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayerFilterContainerComponent.prototype, "hideExportSection", {
        get: function () {
            return this._hideExportSection;
        },
        set: function (value) {
            this._hideExportSection = value;
        },
        enumerable: true,
        configurable: true
    });
    LayerFilterContainerComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.setupMapViewRef(this.mapView)];
                    case 1:
                        _a.mapView = _b.sent();
                        if (this.geographicFilter) {
                            this.geographicFilter.containerElement = this.hostElement;
                            this.geographicFilter.onboundarysourcechanged.subscribe(function (source) {
                                _this.onboundarysourcechanged.emit(source);
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    LayerFilterContainerComponent.prototype.activateTab = function (index) {
        this.currentTabIndex = index;
        if (this.currentTabIndex === 1 && this.geographicFilter) {
            this.onboundarysourcechanged.emit(this.geographicFilter.boundarySource);
            if (!this.geographicFilter.isActivated) {
                this.geographicFilter.activate();
            }
        }
        else {
            this.onboundarysourcechanged.emit(null);
        }
    };
    LayerFilterContainerComponent.prototype.onWorkingQueryChanged = function (data) {
        this.joinFilter.workingQuery = data;
    };
    LayerFilterContainerComponent.prototype.setupFilter = function (layerId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var basicFilter, geographicFilter, joinFilter, childRecordsFilter, hideExportSection, query, filterLayerId, layerColumns, externalLayerId;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        this.esriLayer = this.layerService.getEsriLayerByUniqueId(layerId);
                        basicFilter = this.basicFilter;
                        geographicFilter = this.geographicFilter;
                        joinFilter = this.joinFilter;
                        childRecordsFilter = this.childRecordsFilter;
                        this.exportEnabled = false;
                        hideExportSection = this.hideExportSection ? this.hideExportSection : false;
                        joinFilter.exportJoinColumns = [];
                        joinFilter.hideExportSection = hideExportSection;
                        if (!!this.esriLayer) return [3 /*break*/, 2];
                        this.esriLayerId = this.layerService.getRamdonIdForEsriLayer();
                        return [4 /*yield*/, this.processNewLayer(parseInt(this.layerId, 10), basicFilter, joinFilter, childRecordsFilter, geographicFilter)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        this.esriLayerId = this.esriLayer.id;
                        this.showChildRecordFilter = !this.esriLayer.mapcoreProps.isExternal;
                        this.showJoinFilter = !this.esriLayer.mapcoreProps.isExternal;
                        this.showGeographicFilter = !this.esriLayer.mapcoreProps.isExternal;
                        if (this.esriLayer.mapcoreProps && this.esriLayer.mapcoreProps.exportJoinFilterParams) {
                            joinFilter.exportEnabled = this.esriLayer.mapcoreProps.exportJoinFilterParams.exportEnabled;
                            joinFilter.exportJoinColumns = this.esriLayer.mapcoreProps.exportJoinFilterParams.exportJoinColumns;
                        }
                        else {
                            joinFilter.exportEnabled = false;
                            joinFilter.exportJoinColumns = [];
                        }
                        if (!(this.esriLayer.mapcoreProps && this.esriLayer.mapcoreProps.parentId)) return [3 /*break*/, 4];
                        return [4 /*yield*/, Promise.all([this.isJoinFilter(this.esriLayer.mapcoreProps.parentId), this.isChildRecordFilter(this.esriLayer.mapcoreProps.parentId), this.isGeographicFilter(this.esriLayer.id)])];
                    case 3:
                        _a.sent();
                        if (this.showJoinFilter && !joinFilter.primaryLayerRMSKeys) {
                            joinFilter.primaryLayerRMSKeys = this.primaryLayerRMSKeys;
                        }
                        if (this.showGeographicParams) {
                            geographicFilter.boundarySource = this.showGeographicParams.boundarySource;
                            geographicFilter.boundaryTypes = tslib_1.__spread(this.showGeographicParams.boundaryTypes);
                            geographicFilter.layerId = this.showGeographicParams.layerId;
                            geographicFilter.selectedFeatures = tslib_1.__spread(this.showGeographicParams.selectedFeatures);
                            geographicFilter.selectedCountyCode = this.showGeographicParams.selectedCountyCode;
                            geographicFilter.selectedLayerId = this.showGeographicParams.selectedLayerId;
                            geographicFilter.spatialQuerySelection = this.showGeographicParams.spatialQuerySelection;
                            geographicFilter.workingGuid = this.showGeographicParams.workingGuid;
                            geographicFilter.counties = tslib_1.__spread(this.showGeographicParams.counties);
                        }
                        else {
                            this.geographicFilter.reset();
                        }
                        this.cdr.detectChanges();
                        _a.label = 4;
                    case 4:
                        this.setupNewSubscriptions(basicFilter, hideExportSection, joinFilter, childRecordsFilter, geographicFilter);
                        if (!this.esriLayer) return [3 /*break*/, 8];
                        query = null;
                        if (this.esriLayer.mapcoreProps.query) {
                            query = this.esriLayer.mapcoreProps.query;
                        }
                        filterLayerId = null;
                        layerColumns = [];
                        if (!this.esriLayer.mapcoreProps.id) {
                            filterLayerId = this.esriLayer.mapcoreProps.parentId;
                            if (this.esriLayer.mapcoreProps.parentId === environment.layers.filter(function (x) { return x.name === 'petl'; })[0].id || this.esriLayer.mapcoreProps.isPETL) {
                                layerColumns = this.esriLayer.mapcoreProps.columns;
                            }
                            geographicFilter.esriLayers = [this.esriLayer];
                        }
                        else {
                            filterLayerId = this.esriLayer.mapcoreProps.id;
                            if (this.esriLayer.mapcoreProps && this.esriLayer.mapcoreProps.columns) {
                                layerColumns = this.esriLayer.mapcoreProps.columns;
                            }
                        }
                        if (!(!this.esriLayer.mapcoreProps.id && this.esriLayer.mapcoreProps.isExternal)) return [3 /*break*/, 5];
                        basicFilter.setFilter(null, this.esriLayer, util.deepCopy(layerColumns), query, layerId);
                        return [3 /*break*/, 8];
                    case 5:
                        externalLayerId = this.esriLayer.mapcoreProps.isExternal ? layerId : null;
                        return [4 /*yield*/, basicFilter.setFilter(filterLayerId, this.esriLayer, util.deepCopy(layerColumns), query, externalLayerId)];
                    case 6:
                        _a.sent();
                        return [4 /*yield*/, Promise.all([
                                joinFilter.setFilter(filterLayerId, this.esriLayer, util.deepCopy(layerColumns), basicFilter.query, externalLayerId),
                                childRecordsFilter.setFilter(filterLayerId, this.esriLayer, util.deepCopy(layerColumns), basicFilter.query, externalLayerId)
                            ])];
                    case 7:
                        _a.sent();
                        _a.label = 8;
                    case 8:
                        this.loading = false;
                        this.cdr.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    LayerFilterContainerComponent.prototype.setupNewSubscriptions = function (basicFilter, hideExportSection, joinFilter, childRecordsFilter, geographicFilter) {
        var _this = this;
        this.clearSubs();
        if (!this.basicFilterNewLayerSub) {
            this.basicFilterNewLayerSub = basicFilter.ondone.subscribe(function (data) {
                if (data) {
                    if (_this.exportEnabled && !hideExportSection) {
                        _this.exportToExcel(data.layerId, data.query);
                    }
                    joinFilter.updateQuery(data.query);
                    childRecordsFilter.updateQuery(data.query);
                    data = _this.updateDataWithParams(data);
                    if (_this.geometryString) {
                        data.geometryString = _this.geometryString;
                    }
                    data.esriLayerId = _this.esriLayerId;
                    _this.onapply.emit({ id: _this.layerId, data: data });
                }
            });
        }
        if (!this.geoFilterNewLayerSub) {
            this.geoFilterNewLayerSub = geographicFilter.ondone.subscribe(function (data) {
                if (_this.exportEnabled && !hideExportSection) {
                    _this.exportToExcel(data.layerId, data.query);
                }
                basicFilter.updateQuery(data.query);
                childRecordsFilter.updateQuery(data.query);
                data = _this.updateDataWithParams(data);
                if (_this.geometryString) {
                    data.geometryString = _this.geometryString;
                }
                data.esriLayerId = _this.esriLayerId;
                _this.isGeographicFilter(_this.esriLayerId, true);
                _this.onapply.emit({ id: _this.layerId, data: data });
            });
        }
        if (!this.joinFilterNewLayerSub && this.showJoinFilter) {
            this.joinFilterNewLayerSub = joinFilter.ondone.subscribe(function (data) {
                if (data) {
                    if (_this.exportEnabled && !hideExportSection) {
                        _this.exportToExcel(data.layerId, data.query);
                    }
                    basicFilter.updateQuery(data.query);
                    childRecordsFilter.updateQuery(data.query);
                    data = _this.updateDataWithParams(data);
                    if (_this.geometryString) {
                        data.geometryString = _this.geometryString;
                    }
                    data.esriLayerId = _this.esriLayerId;
                    _this.onapply.emit({ id: _this.layerId, data: data });
                }
            });
        }
        if (!this.childRecordsFilterNewLayerSub && this.showChildRecordFilter) {
            this.childRecordsFilterNewLayerSub = childRecordsFilter.ondone.subscribe(function (data) {
                if (data) {
                    if (_this.exportEnabled && !hideExportSection) {
                        _this.exportToExcel(data.layerId, data.query);
                    }
                    joinFilter.updateQuery(data.query);
                    basicFilter.updateQuery(data.query);
                    data = _this.updateDataWithParams(data);
                    if (_this.geometryString) {
                        data.geometryString = _this.geometryString;
                    }
                    data.esriLayerId = _this.esriLayerId;
                    _this.onapply.emit({ id: _this.layerId, data: data });
                }
            });
        }
        if (!this.basicWorkingQuerySub) {
            this.basicWorkingQuerySub = basicFilter.workingQueryChange.subscribe(function (data) {
                if (data && data.workingQuery) {
                    if (data.workingQuery !== joinFilter.workingQuery) {
                        _this.childRecordsFilter.workingQuery = util.deepCopy(data.workingQuery);
                        _this.joinFilter.workingQuery = util.deepCopy(data.workingQuery);
                    }
                    _this.layerColumns = data.layerColumns;
                    var summaryString = _this.filterService.populateSummaryFromQuery(data.workingQuery, _this.layerColumns, _this.joinColumns, _this.childColumns);
                    basicFilter.updateWorkingSql(summaryString);
                    joinFilter.updateWorkingSql(summaryString);
                    childRecordsFilter.updateWorkingSql(summaryString);
                }
            });
        }
        if (!this.geometryStringSub) {
            this.geometryStringSub = geographicFilter.selectedGeometryChange.subscribe(function (data) {
                if (data) {
                    _this.geometryString = data.geometryString;
                }
            });
        }
        if (!this.joinWorkingQuerySub) {
            this.joinWorkingQuerySub = joinFilter.workingQueryChange.subscribe(function (data) {
                if (data && basicFilter.workingQuery && data.workingQuery) {
                    if (data.workingQuery !== basicFilter.workingQuery) {
                        _this.basicFilter.workingQuery = util.deepCopy(data.workingQuery);
                        _this.childRecordsFilter.workingQuery = util.deepCopy(data.workingQuery);
                    }
                    if (_this.joinColumns !== data.joinColumns) {
                        _this.joinColumns = data.joinColumns;
                    }
                    var summaryString = _this.filterService.populateSummaryFromQuery(data.workingQuery, _this.layerColumns, _this.joinColumns, _this.childColumns);
                    basicFilter.updateWorkingSql(summaryString);
                    joinFilter.updateWorkingSql(summaryString);
                    childRecordsFilter.updateWorkingSql(summaryString);
                }
            });
        }
        if (!this.childRecordSub) {
            this.childRecordSub = childRecordsFilter.workingQueryChange.subscribe(function (data) {
                if (data && basicFilter.workingQuery && data.workingQuery) {
                    if (data.workingQuery !== basicFilter.workingQuery) {
                        _this.basicFilter.workingQuery = data.workingQuery;
                        _this.joinFilter.workingQuery = data.workingQuery;
                    }
                    if (_this.childColumns !== data.childColumns) {
                        _this.childColumns = data.childColumns;
                    }
                    var summaryString = _this.filterService.populateSummaryFromQuery(data.workingQuery, _this.layerColumns, _this.joinColumns, _this.childColumns);
                    basicFilter.updateWorkingSql(summaryString);
                    joinFilter.updateWorkingSql(summaryString);
                    childRecordsFilter.updateWorkingSql(summaryString);
                }
            });
        }
        if (!this.filterExistingLayerSub) {
            this.filterExistingLayerSub = basicFilter.ondone.subscribe(function (data) {
                _this.updateMapcoreProps(data);
            });
        }
        if (!this.joinFilterExistingLayerSub) {
            this.joinFilterExistingLayerSub = joinFilter.ondone.subscribe(function (data) {
                _this.updateMapcoreProps(data);
            });
        }
        if (!this.childRecordsFilterExistingLayerSub) {
            this.childRecordsFilterExistingLayerSub = childRecordsFilter.ondone.subscribe(function (data) {
                _this.updateMapcoreProps(data);
            });
        }
        if (!this.exportExcelSub) {
            this.exportExcelSub = joinFilter.exportOptionChange.subscribe(function (data) {
                if (data) {
                    _this.exportEnabled = data.exportEnabled;
                    _this.layerColumns = data.layerColumns;
                    _this.exportJoinColumns = data.exportJoinColumns;
                }
            });
        }
        if (!this.layerDataSub) {
            this.layerDataSub = basicFilter.onlayerdata.subscribe(function (data) { return _this.onlayerdata.emit(data); });
        }
    };
    LayerFilterContainerComponent.prototype.clearSubs = function () {
        if (this.basicFilterNewLayerSub) {
            this.basicFilterNewLayerSub.unsubscribe();
            this.basicFilterNewLayerSub = null;
        }
        if (this.geoFilterNewLayerSub) {
            this.geoFilterNewLayerSub.unsubscribe();
            this.geoFilterNewLayerSub = null;
        }
        if (this.joinFilterNewLayerSub) {
            this.joinFilterNewLayerSub.unsubscribe();
            this.joinFilterNewLayerSub = null;
        }
        if (this.childRecordsFilterNewLayerSub) {
            this.childRecordsFilterNewLayerSub.unsubscribe();
            this.childRecordsFilterNewLayerSub = null;
        }
        if (this.basicWorkingQuerySub) {
            this.basicWorkingQuerySub.unsubscribe();
            this.basicWorkingQuerySub = null;
        }
        if (this.joinWorkingQuerySub) {
            this.joinWorkingQuerySub.unsubscribe();
            this.joinWorkingQuerySub = null;
        }
        if (this.childRecordSub) {
            this.childRecordSub.unsubscribe();
            this.childRecordSub = null;
        }
        if (this.filterExistingLayerSub) {
            this.filterExistingLayerSub.unsubscribe();
            this.filterExistingLayerSub = null;
        }
        if (this.joinFilterExistingLayerSub) {
            this.joinFilterExistingLayerSub.unsubscribe();
            this.joinFilterExistingLayerSub = null;
        }
        if (this.childRecordsFilterExistingLayerSub) {
            this.childRecordsFilterExistingLayerSub.unsubscribe();
            this.childRecordsFilterExistingLayerSub = null;
        }
        if (this.exportExcelSub) {
            this.exportExcelSub.unsubscribe();
            this.exportExcelSub = null;
        }
        if (this.layerDataSub) {
            this.layerDataSub.unsubscribe();
            this.layerDataSub = null;
        }
    };
    LayerFilterContainerComponent.prototype.processNewLayer = function (layerId, basicFilter, joinFilter, childRecordsFilter, geographicFilter) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var extraFilters;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all([this.isJoinFilter(layerId), this.isChildRecordFilter(layerId)])];
                    case 1:
                        _a.sent();
                        if (!this.extraQuery) {
                            basicFilter.query = {};
                        }
                        else {
                            extraFilters = this.extraQuery.subqueries.filter(function (x) { return x.field === 'MAINT_FY' || x.field === 'CALENDAR_YEAR'; });
                            if (extraFilters.length > 0) {
                                basicFilter.extraFilters = extraFilters;
                                basicFilter.query = {};
                            }
                            else {
                                basicFilter.query = this.extraQuery;
                            }
                        }
                        basicFilter.layerId = layerId;
                        basicFilter.esriLayer = null;
                        if (this.showJoinFilter) {
                            joinFilter.primaryLayerRMSKeys = this.primaryLayerRMSKeys;
                            basicFilter.query.joinTableQuery = {};
                            joinFilter.query = basicFilter.query;
                            joinFilter.layerId = layerId;
                        }
                        if (this.showChildRecordFilter) {
                            basicFilter.query.childTableQuery = {};
                            childRecordsFilter.query = basicFilter.query;
                            childRecordsFilter.layerId = layerId;
                        }
                        this.geographicFilter.reset();
                        geographicFilter.layerId = layerId;
                        geographicFilter.esriLayerId = this.esriLayerId;
                        geographicFilter.esriLayers = [];
                        this.cdr.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    LayerFilterContainerComponent.prototype.updateMapcoreProps = function (data) {
        try {
            if (this.esriLayer && data) {
                this.esriLayer.mapcoreProps.filter = data.sql;
                this.esriLayer.mapcoreProps.query = data.query;
                this.esriLayer.mapcoreProps.joinColumns = this.joinColumns;
                this.esriLayer.mapcoreProps.childColumns = this.childColumns;
                this.esriLayer.mapcoreProps.exportJoinFilterParams = { exportEnabled: this.exportEnabled };
                if (this.esriLayer.mapcoreProps.exportJoinFilterParams) {
                    this.esriLayer.mapcoreProps.exportJoinFilterParams.exportEnabled = this.exportEnabled;
                    this.esriLayer.mapcoreProps.exportJoinFilterParams.exportJoinColumns = this.exportJoinColumns;
                }
                this.layerService.updateLayerFilter(this.esriLayer, data.query);
                this.onapply.emit({ esriLayer: this.esriLayer });
            }
            else {
                this.ondone.emit();
            }
        }
        catch (_a) { }
    };
    LayerFilterContainerComponent.prototype.isJoinFilter = function (layerId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var cacheShowFilter, layers, tables, table, result, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        cacheShowFilter = this.joinFilterList.filter(function (x) { return x.layerId === layerId; });
                        if (!(cacheShowFilter && cacheShowFilter.length > 0)) return [3 /*break*/, 1];
                        this.showJoinFilter = cacheShowFilter[0].show;
                        if (this.showJoinFilter) {
                            this.primaryLayerRMSKeys = cacheShowFilter[0].rmsKeys;
                        }
                        return [3 /*break*/, 6];
                    case 1: return [4 /*yield*/, this.filterService.getLayerData(layerId)];
                    case 2:
                        layers = _b.sent();
                        tables = layers[0].tables;
                        table = tables.sort(function (a, b) { return a.geometryType.localeCompare(b.geometryType); })[0];
                        if (!table) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.layerService.getTableRMSKeysByName(table.owner + "." + table.name)];
                    case 3:
                        _a = _b.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        _a = null;
                        _b.label = 5;
                    case 5:
                        result = _a;
                        this.showJoinFilter = (result !== null);
                        if (result && result.offsetEndColName) {
                            result.isOffsetNumber = this.filterService.offSetIsNumber(result.offsetEndColName, layers[0].columns);
                        }
                        this.primaryLayerRMSKeys = result;
                        this.joinFilterList.push({ layerId: layerId, show: this.showJoinFilter, rmsKeys: result });
                        _b.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    LayerFilterContainerComponent.prototype.isChildRecordFilter = function (layerId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var cacheShowFilter, relationships;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cacheShowFilter = this.childFilterList.filter(function (x) { return x.layerId === layerId; });
                        if (!(cacheShowFilter && cacheShowFilter.length > 0)) return [3 /*break*/, 1];
                        this.showChildRecordFilter = cacheShowFilter[0].show;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.layerService.getLayerChildTableRelationships(layerId)];
                    case 2:
                        relationships = _a.sent();
                        this.showChildRecordFilter = (relationships !== null && !!relationships.length);
                        this.childFilterList.push({ layerId: layerId, show: this.showChildRecordFilter });
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LayerFilterContainerComponent.prototype.isGeographicFilter = function (layerId, overwrite) {
        if (overwrite === void 0) { overwrite = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var cacheShowFilter;
            return tslib_1.__generator(this, function (_a) {
                cacheShowFilter = this.geographicFilterList.filter(function (x) { return x.layerId === layerId; });
                if (cacheShowFilter && cacheShowFilter.length > 0) {
                    if (overwrite) {
                        cacheShowFilter[0].show = tslib_1.__assign({}, this.geographicFilter);
                    }
                    else {
                        this.showGeographicParams = cacheShowFilter[0].show;
                    }
                }
                else if (this.geographicFilter.boundaryTypes && this.geographicFilter.boundaryTypes.length && this.geographicFilter.boundaryTypes.length > 0) {
                    this.showGeographicParams = tslib_1.__assign({}, this.geographicFilter);
                    this.geographicFilterList.push({ layerId: layerId, show: this.showGeographicParams });
                }
                return [2 /*return*/];
            });
        });
    };
    LayerFilterContainerComponent.prototype.exportToExcel = function (layerId, query) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var exportParameters, columns_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.exportEnabled) return [3 /*break*/, 2];
                        exportParameters = {
                            layerId: layerId,
                            query: query,
                            title: 'export'
                        };
                        exportParameters.fieldNames = this.layerColumns.map(function (x) { return x.name; });
                        exportParameters.joinFieldNames = this.exportJoinColumns.map(function (x) { return x.name; });
                        columns_1 = [];
                        this.exportJoinColumns.forEach(function (joinColumn) {
                            var col = {
                                alias: joinColumn.name + "_1",
                                name: joinColumn.name,
                                databaseDataType: joinColumn.dataType,
                                databaseColumnOrder: 0,
                                isCommaSeparated: false
                            };
                            columns_1.push(col);
                        });
                        exportParameters.joinColumns = columns_1;
                        return [4 /*yield*/, this.exportService.exportToExcelAndOpenUrl(exportParameters)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    LayerFilterContainerComponent.prototype.updateDataWithParams = function (data) {
        if (this.joinColumns) {
            data.joinColumns = this.joinColumns;
        }
        if (this.childColumns) {
            data.childColumns = this.childColumns;
        }
        data.exportJoinFilterParams = { exportEnabled: this.exportEnabled };
        if (this.exportEnabled) {
            data.exportEnabled = this.exportEnabled;
            data.exportJoinColumns = this.exportJoinColumns;
        }
        if (this.geometryString) {
            data.geometryString = this.geometryString;
        }
        return data;
    };
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], LayerFilterContainerComponent.prototype, "enableGeographicFilter", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], LayerFilterContainerComponent.prototype, "enableJoinFilter", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], LayerFilterContainerComponent.prototype, "enableChildRecordFilter", void 0);
    return LayerFilterContainerComponent;
}(BaseComponent));
export { LayerFilterContainerComponent };
